// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
}

.firstCol {
    cursor: default;
    grid-column: 1;
}

.secondCol {
    grid-column: 2;
}

.foreign {
    color: red;
}

.serviceLog {
    color: darkblue;
}

.selectedLog {
    background-color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/app/debugconsole/workflow/debug.workflow.log.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":[".grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n}\n\n.firstCol {\n    cursor: default;\n    grid-column: 1;\n}\n\n.secondCol {\n    grid-column: 2;\n}\n\n.foreign {\n    color: red;\n}\n\n.serviceLog {\n    color: darkblue;\n}\n\n.selectedLog {\n    background-color: var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
